module.exports = __webpack_public_path__ + "890c744000bc35749dbdb727154c9d16.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/audio-icon.png
// module id = 20
// module chunks = 0